<template>
	<main class="school-mgn-list" style="background: #f5f5fb;">
		<div class="mainList">
			<el-form label-width="80px" ref="searchForm" :model="search" :inline="true" style="margin-left: 13px;padding: 5px 0">
				<el-form-item prop="fb_region_code">
					<el-cascader
						ref="cascaderArr"
						v-model="search.fb_region_code"
						size="small"
						:options="addressOptions"
						:props="{
							value: 'id',
							label: 'name',
							children: 'child',
							expandTrigger: 'click',
							emitPath: false,
              checkStrictly: true
						}"
            @change="(currentPage = 1), refreshDataList()"
					>
					</el-cascader>
				</el-form-item>
				<el-form-item prop="realname">
					<el-input
						style="width: 150px;"
						placeholder="教研名字"
						@keyup.native.enter=";(currentPage = 1), refreshDataList()"
						v-model="search.realname"
						size="small"
					>
					</el-input>
				</el-form-item>
			</el-form>

			<div style="display: flex; margin-left: auto;">
				<template>
					<el-button
						type="primary"
						class="action-btn"
						size="small"
						style="margin-right: 15px; width: 70px;"
						@click=";(currentPage = 1), refreshDataList()"
						>搜索</el-button
					>
					<el-button
						type="primary"
						class="action-btn"
						size="small"
						style="
							background: #f7f8fa;
							border: 1px solid #dcdcdc;
							color: #4b4b4b !important;
							margin-right: 12px;
							width: 70px;
						"
						@click="resetForm('searchForm')"
						>重置</el-button
					>
				</template>
			</div>
		</div>
		<div>
			<section class="list-area">
				<div class="list-area-otis">
					<template>
						<div style="display: flex; padding-left: 18px;">
							<el-button
								type="primary"
								size="small"
								icon="el-icon-plus"
								style="margin-right: 15px;"
                @click="paramsTitle = '新建教研员', newVisible = true"
								>新建</el-button
							>
							<el-button
								size="small"
								icon="el-icon-download"
								style="background: #f7f8fa; border: 2px solid #f7f8fa; color: #4b4b4b !important;"
								@click="$refs.importDialog.dialogVisible = true"
								>批量创建</el-button
							>
							<el-button
								size="small"
								icon="el-icon-upload2"
								style="background: #f7f8fa; border: 2px solid #f7f8fa; color: #4b4b4b !important;"
								v-if="multipleSelection.length > 0"
                @click="exportExcel('assistants', '教研数据')"
								>导出</el-button
							>
						</div>
						<div>
							<el-button
								type="primary"
								size="small"
								icon="el-icon-delete"
								:class="multipleSelection.length === 0 ? 'box' : 'box2'"
								:disabled="multipleSelection.length === 0"
								v-if="multipleSelection.length > 0"
                @click="promptRemove(multipleSelection.map(item => item.uid))"
								>批量删除</el-button
							>
							<el-button
								type="primary"
								size="small"
								icon="el-icon-refresh-right"
								:class="multipleSelection.length === 0 ? 'box' : 'box2'"
								:disabled="multipleSelection.length === 0"
								v-if="multipleSelection.length > 0"
                @click="resetPwd(multipleSelection.map(item => item.uid))"
								>重置密码</el-button
							>
						</div>
					</template>
				</div>
				<el-table
					:data="dataList"
					row-class-name="row"
					tooltip-effect="dark"
					@selection-change="$event => multipleSelection = $event"
					:header-cell-style="{ background: '#FAFAFA', color: '#000000', height: '10px !important' }"
				>
					<el-table-column type="selection" width="60" align="center"></el-table-column>
          <el-table-column align="left" label="ID" prop="uid"></el-table-column>
          <el-table-column align="left" label="层级" prop="admin_level" :formatter="admin_level"></el-table-column>
          <el-table-column align="left" label="辖区" prop="district" :formatter="district_name"></el-table-column>
          <el-table-column align="left" label="教研员名字" prop="account.realname"></el-table-column>
          <el-table-column align="left" label="账号" prop="account.login_name"></el-table-column>
          <el-table-column align="left" label="手机号" prop="account.mobile"></el-table-column>
          <el-table-column align="left" label="账号状态" prop="account.state">
            <template slot-scope="scope">
							<div style="display: flex; justify-content: left; align-items: center;">
								<span slot="reference" v-show="scope.row.account?.state === 0" style="margin-right: 5px;">
									<i class="dotClass" style="background-color: #67c23a;"></i>
								</span>
								<span slot="reference" v-show="scope.row.account?.state === 1" style="margin-right: 5px;">
									<i class="dotClass" style="background-color: #b81a19;"></i>
								</span>
								{{ scope.row.account?.state === 0 ? '使用中' : '已停用' }}
							</div>
						</template>
          </el-table-column>
          <el-table-column align="center" label="操作" class-name="opscol" width="170">
            <template v-slot:default="slot">
              <div class="table-mgn2">
                <div style="color: #3f6af7;" @click="promptEdit(slot.row)">
                  <el-tooltip content="编辑" placement="bottom" effect="light">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#icon-iconoutlinesetting"></use>
                    </svg>
                  </el-tooltip>
                </div>

                <div
                  class="icon delete"
                  style="color: #f13048;"
                  @click="promptRemove([slot.row.uid])"
                >
                  <el-tooltip content="删除" placement="bottom" effect="light">
                    <svg
                      class="icon"
                      aria-hidden="true"
                      style="width: 100%; height: 100%; outline: none; box-shadow: none;"
                    >
                      <use xlink:href="#icon-deltred"></use>
                    </svg>
                  </el-tooltip>
                </div>

                <div
                  v-show="slot.row.account.state === 0"
                  class="icon delete"
                  style="color: #f13048;"
                  @click="prompState(slot.row.uid)"
                >
                  <el-tooltip content="禁用" placement="bottom" effect="light">
                    <svg
                      class="icon"
                      aria-hidden="true"
                      style="width: 100%; height: 100%; outline: none; box-shadow: none;"
                    >
                      <use xlink:href="#icon-prohibit"></use>
                    </svg>
                  </el-tooltip>
                </div>
                <div
                  v-show="slot.row.account.state === 1"
                  class="icon delete"
                  style="color: #4ab96d;"
                  @click="prompState(slot.row.uid)"
                >
                  <el-tooltip content="启用" placement="bottom" effect="light">
                    <i aria-hidden="true" class="icon el-icon-circle-check"></i>
                  </el-tooltip>
                </div>

                <div style="color: #666666;" @click="resetPwd([slot.row.uid])">
                  <el-tooltip content="重置" placement="bottom" effect="light">
                    <i aria-hidden="true" class="icon el-icon-refresh-right"></i>
                  </el-tooltip>
                </div>
              </div>
            </template>
          </el-table-column>
				</el-table>
				<div class="pagination-page">
					<span class="pagetotal">总计：{{ totalItems }}条/{{ Math.ceil(totalItems / pageSize) }}页</span>
					<el-pagination
						class="pagination"
						background
						@size-change="$event => { (pageSize = $event), refreshDataList() }"
						@current-change="$event => { (currentPage = $event), refreshDataList() }"
						:page-size="pageSize"
						:total="totalItems"
						:current-page.sync="currentPage"
						:page-sizes="[10, 20, 50, 100]"
						layout="prev,pager,next,jumper,sizes"
						style="margin-top: 21px; margin-left: 10px;"
					>
					</el-pagination>
				</div>
			</section>
		</div>
		<!-- 批量导入 -->
		<batch-import-account ref="importDialog" :target="'assistant'" />

    <el-dialog
			class="scope-dialog"
			:width="'400px'"
			:close-on-click-modal="false"
			:visible="newVisible"
      @before-close="resetForm('newParams')"
			@close="resetForm('newParams')"
      :destroy-on-close="true"
			:title="paramsTitle"
		>
			<el-divider></el-divider>
			<el-form :model="newParams" :rules="applicationRules" ref="newParams">
        <el-form-item prop="admin_level" _m="!t-25px">
          <el-select @change="changeAdminLevel" v-model="newParams.admin_level" size="medium" style="width: 100%;" placeholder="层级">
						<el-option
							v-for="item in schoolLevel"
							:key="item.val"
							:label="item.name"
							:value="item.val"
						></el-option>
					</el-select>
        </el-form-item>
				<el-form-item prop="region_code" _m="!t-25px">
					<el-cascader
            :disabled="!!!newParams.admin_level"
						style="width: 100%"
						ref="cascaderArrObj"
						placeholder="请选择辖区"
						v-model="newParams.region_code"
						size="medium"
						:options="addressLevelOptions"
						:props="{
							value: 'id',
							label: 'name',
							children: 'child',
							expandTrigger: 'click',
							emitPath: false
						}"
					>
					</el-cascader>
				</el-form-item>
        <el-form-item prop="realname" _m="!y-25px">
          <el-input placeholder="真实姓名" v-model="newParams.realname" @input="e => (newParams.realname = validForbid(e))" style="width: 100%;" size="medium" />
        </el-form-item>
			</el-form>
			<el-divider></el-divider>
			<div _flex="~ items-center justify-center" _m="y-20px">
				<el-button class="btn-close" @click="resetForm('newParams')" _w="!80px" _h="!32px" style="line-height: 1px;"
					>取 消</el-button
				>
				<el-button
					class="btn-prim"
					type="primary"
					@click="boxConfirmEvent('newParams')"
					_w="!80px"
					_h="!32px"
					style="line-height: 1px;"
					>确定</el-button
				>
			</div>
		</el-dialog>
	</main>
</template>
<script>
import BatchImportAccount from '@/components/BatchImportAccount'
import { schoolLevel, applicationRules } from './const.js'
export default {
	props: [],
	data() {
		return {
			schoolLevel, applicationRules,
      dataList: [],
      totalItems: 0,
      pageSize: 10,
      currentPage: 1,
      search: {
        fb_region_code: '',
        realname: ''
      },
      multipleSelection: [],
      addressOptions: [],
      addressLevelOptions: [],
      newVisible: false,
      newParams: {
        region_code: '',
        realname: '',
        admin_level: ''
      },
      paramsTitle: '新建教研员',
      rowUid: ''
		}
	},
  methods: {
    changeAdminLevel(level) {
      this.addressLevelOptions = this.recursiveChange(this.addressOptions, level)
      this.newParams.region_code = ''
    },
    recursiveChange(items, level) {
      return items.map(item => ({
        ...item,
        child: level > 1 ? this.recursiveChange(item.child || [], level - 1) : undefined
      }))
    },
    boxConfirmEvent(formName) {
			this.$refs[formName].validate(async valid => {
				if (valid) {
          if (this.paramsTitle == '新建教研员') {
            await this.$api.teacher_lan.addAssistants({
              ...this.newParams,
              region_code: Array.isArray(this.newParams.region_code) ? this.newParams.region_code[0] : this.newParams.region_code
            })
            this.$message.success('新建成功，请刷新数据')
          } else if (this.paramsTitle == '编辑教研员') {
            await this.$api.teacher_lan.updateAssistants(this.rowUid, {
              ...this.newParams,
              region_code: Array.isArray(this.newParams.region_code) ? this.newParams.region_code[0] : this.newParams.region_code
            })
            this.$message.success('更新成功，请刷新数据')
          }
					this.resetForm('newParams')
          this.refreshDataList()
				} else {
					return false
				}
			})
		},
    resetForm(formName) {
			this.$refs[formName].resetFields()
      if (formName == 'newParams') {
        this.newParams = {}
        this.newVisible = false
        return
      }
			this.refreshDataList()
		},
    async refreshDataList() {
      const { data, meta } = await this.$api.teacher_lan.getAssistantsList({
        ...this.search,
        page: this.currentPage,
        page_size: this.pageSize
      })
      this.dataList = data
      this.totalItems = meta.total
    },
    async RegionalLevel() {
			const res = await this.$api.school.ssxlist(0)
      this.addressOptions = this.removeEmptyItems(res)
		},
    promptRemove(ids) {
			this.$confirm('是否删除该教研人员?', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				await this.$api.teacher_lan.deleteAssistants({
          ids: ids
        })
				this.$message.success('删除成功，请刷新数据')
				this.refreshDataList()
			})
		},
    promptEdit(row) {
      this.paramsTitle = '编辑教研员'
      const { district, admin_level, account, uid } = row
      this.rowUid = uid
      this.changeAdminLevel(admin_level)
      const { l1_id, l2_id, l3_id } = district
      this.newParams = {
        region_code: admin_level == 1 ? [l1_id] : admin_level == 2 ? [l1_id, l2_id] : [l1_id, l2_id, l3_id],
        realname: account?.realname,
        admin_level: admin_level
      }
      this.newVisible = true
    },
    prompState(id) {
			this.$confirm('此操作将修改用户状态?', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				await this.$api.teacher.ResetState(id)
				this.refreshDataList()
			})
		},
    resetPwd(ids) {
			this.$confirm('此操作将重置密码, 是否继续?', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
        const cRes = await this.$api.teacher_lan.resetPwdAssistants({ ids: ids })
        if (cRes.success === true) {
          this.$message.success('重置密码成功！选中账号的初始密码为：000000')
          this.refreshDataList()
        }
      })
		},
    async exportExcel(key, fileName) {
			this.$confirm(`是否要导出登录密码?`, '温馨提示', {
				distinguishCancelAndClose: true,
				confirmButtonText: '是',
				cancelButtonText: '否',
				type: 'warning'
			})
				.then(async () => {
					let blob = await this.$api.import_account.exportis(key, {
						ids: this.multipleSelection.map(item => {
							return item.uid
						}),
						has_password: true
					})
					this.downloadFile(blob, fileName)
				})
				.catch(async action => {
					if (action === 'close') {
						return
					}
					let blob = await this.$api.import_account.exportis(key, {
						ids: this.multipleSelection.map(item => {
							return item.uid
						}),
						has_password: false
					})
					this.downloadFile(blob, fileName)
				})
		},
		downloadFile(blob, fileName) {
			const url = window.URL.createObjectURL(new Blob([blob]))
			let a = document.createElement('a')
			a.href = url
			a.download = `${fileName}.xlsx`
			a.click()
			window.URL.revokeObjectURL(url)
		},
    removeEmptyItems(arr, name = 'child') {
			const newArr = []
			for (let i = 0; i < arr.length; i++) {
				const item = arr[i]
				if (item[name]?.length >= 1) {
					item[name] = this.removeEmptyItems(item[name])
				} else {
					item[name] = undefined
				}
				newArr.push(item)
			}
			return newArr
		},
    admin_level(row) {
      return this.schoolLevel.find(item => item.val == row.admin_level).name
    },
    district_name(row) {
      if (row.admin_level == 1) {
        return `${row.district.l1_name}`
      } else if (row.admin_level == 2) {
        return `${row.district.l1_name}/${row.district.l2_name}`
      } else if (row.admin_level == 3) {
        return `${row.district.l1_name}/${row.district.l2_name}/${row.district.l3_name}`
      }
    }
  },
  created() {
    this.RegionalLevel()
    this.refreshDataList()
  },
	components: {
		BatchImportAccount
	},
}
</script>
<style lang="scss" scoped>
.action-btn:focus {
	background-color: #ff5e2a;
	border-color: #ff5e2a;
	opacity: 1 !important;
}
.box {
	margin-right: 15px;
	background: #9f9f9f;
	border: 2px solid #f7f8fa;
	color: #4b4b4b !important;
}
.box:hover {
	margin-right: 15px;
	background: #9f9f9f;
	border: 2px solid #f7f8fa;
	color: #4b4b4b !important;
}
.box2 {
	margin-right: 15px;
	background: #f7f8fa;
	border: 2px solid #f7f8fa;
	color: #4b4b4b !important;
}

.pagetotal {
	width: 200px;
	margin-left: 20px;
	font-size: 14px;
	line-height: 70px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #010101;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
}
.addr {
	font-size: 14px;
	color: #b4b4b4;
}
.dotClass {
	width: 10px;
	height: 10px;
	border-radius: 50%;
	display: block;
}
.schoolNianji {
	width: 32px;
	height: 28px;
	font-size: 16px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #323232;
	line-height: 28px;
	-webkit-background-clip: text;
}
.schollAxie {
	height: 35px;
	display: flex;
	-webkit-box-pack: justify;
	justify-content: space-between;
	vertical-align: middle;
	-webkit-box-align: center;
	align-items: center;
}
.schollApex {
	width: 32px;
	height: 28px;
	font-size: 16px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #323232;
	line-height: 28px;
	-webkit-background-clip: text;
	display: flex;
}
.el-form-item {
	margin-bottom: 1px;
}
.pagination {
	width: 100%;
	margin-top: 20px;
	text-align: right;
}
.pagination .el-pagination__total {
	float: left;
	font-size: 14px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #010101;
	-webkit-background-clip: text;
}
.pagination .el-pagination__jump {
	margin-left: 9px;
	font-weight: normal;
	color: #666666;
}
.ClassesRadio {
	margin-right: 32px;
	padding-bottom: 15px;
	font-size: 16px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #323232;
	-webkit-background-clip: text;
}
.ClassChekbox {
	margin-right: 8px;
	width: 90px;
	height: 32px;
	padding-bottom: 0px;
	font-size: 16px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #323232;
	-webkit-background-clip: text;
}
</style>
